import { render, staticRenderFns } from "./UploadArchiveMenuButton.vue?vue&type=template&id=287d7a64&"
import script from "./UploadArchiveMenuButton.vue?vue&type=script&lang=ts&"
export * from "./UploadArchiveMenuButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports